/* tslint:disable */
/* eslint-disable */
/**
 * Ankieter API
 * Ankieter 6.0 - the API contract, source of truth for the backend and the frontend
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from '../configuration';
import type { AxiosPromise, AxiosInstance, RawAxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from '../common';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, type RequestArgs, BaseAPI, RequiredError, operationServerMap } from '../base';
// @ts-ignore
import type { CsrfTokenDto } from '../models';
/**
 * CsrfApi - axios parameter creator
 * @export
 */
export const CsrfApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * The token is stable within a session (HttpSessionCsrfTokenRepository), so the frontend fetches it once and attaches it to every state-changing request.
         * @summary CSRF token of the current session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsrfToken: async (options: RawAxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/v1/csrf`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CsrfApi - functional programming interface
 * @export
 */
export const CsrfApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CsrfApiAxiosParamCreator(configuration)
    return {
        /**
         * The token is stable within a session (HttpSessionCsrfTokenRepository), so the frontend fetches it once and attaches it to every state-changing request.
         * @summary CSRF token of the current session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCsrfToken(options?: RawAxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CsrfTokenDto>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCsrfToken(options);
            const localVarOperationServerIndex = configuration?.serverIndex ?? 0;
            const localVarOperationServerBasePath = operationServerMap['CsrfApi.getCsrfToken']?.[localVarOperationServerIndex]?.url;
            return (axios, basePath) => createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration)(axios, localVarOperationServerBasePath || basePath);
        },
    }
};

/**
 * CsrfApi - factory interface
 * @export
 */
export const CsrfApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CsrfApiFp(configuration)
    return {
        /**
         * The token is stable within a session (HttpSessionCsrfTokenRepository), so the frontend fetches it once and attaches it to every state-changing request.
         * @summary CSRF token of the current session
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCsrfToken(options?: RawAxiosRequestConfig): AxiosPromise<CsrfTokenDto> {
            return localVarFp.getCsrfToken(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CsrfApi - interface
 * @export
 * @interface CsrfApi
 */
export interface CsrfApiInterface {
    /**
     * The token is stable within a session (HttpSessionCsrfTokenRepository), so the frontend fetches it once and attaches it to every state-changing request.
     * @summary CSRF token of the current session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsrfApiInterface
     */
    getCsrfToken(options?: RawAxiosRequestConfig): AxiosPromise<CsrfTokenDto>;

}

/**
 * CsrfApi - object-oriented interface
 * @export
 * @class CsrfApi
 * @extends {BaseAPI}
 */
export class CsrfApi extends BaseAPI implements CsrfApiInterface {
    /**
     * The token is stable within a session (HttpSessionCsrfTokenRepository), so the frontend fetches it once and attaches it to every state-changing request.
     * @summary CSRF token of the current session
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CsrfApi
     */
    public getCsrfToken(options?: RawAxiosRequestConfig) {
        return CsrfApiFp(this.configuration).getCsrfToken(options).then((request) => request(this.axios, this.basePath));
    }
}

